import * as Yup from "yup";

const CompanyOrganizationSchema = Yup.object().shape({
  level: Yup.string().required("Please enter your level."),
  under: Yup.string().when("level", {
    is: (val) => val === null,
    then: () => Yup.string().required("Please enter your Under"),
    otherwise: () => Yup.string().notRequired(),
  }),
  agencyCode: Yup.string().required("Please enter your  Agency Code"),
  organizationLevelNameTH: Yup.string().required(
    "Please enter your  Organization Level Name (TH) "
  ),
  organizationLevelNameEN: Yup.string().required(
    "Please enter your  Organization Level Name (EN) "
  ),
  // costCenter: Yup.string().when("information", {
  //   is: (val) => val === true,
  //   then: () => Yup.string().required("Please enter your  Cost Center"),
  //   otherwise: () => Yup.string().notRequired(),
  // }),
  // businessUnit: Yup.string().when("information", {
  //   is: (val) => val === true,
  //   then: () => Yup.string().required("Please enter your   business unit"),
  //   otherwise: () => Yup.string().notRequired(),
  // }),
  accountTypeCodes: Yup.string().when("information", {
    is: (val) => val === true,
    then: () => Yup.string().required("Please enter your  account Type Codes"),
    otherwise: () => Yup.string().notRequired(),
  }),
  socialSecurityBranchOptions: Yup.string().when("level", {
    is: (val) => val === null,
    then: () =>
      Yup.string().required(
        "Please enter your  social security branch Options"
      ),
    otherwise: () => Yup.string().notRequired(),
  }),
});

export default CompanyOrganizationSchema;
